/** Identificador de Matriz/Filial da empresa */
export interface IdentificadorMatrizFilial {
    id: number;
    nome: string;
    badge: string;
}

export const identificadorMatriz: IdentificadorMatrizFilial = {
    id: 1,
    nome: 'Matriz',
    badge: 'badge badge-identificador-matriz'
};
export const identificadorFilial: IdentificadorMatrizFilial = {
    id: 2,
    nome: 'Filial',
    badge: 'badge badge-identificador-filial'
};

export const identificadoresMatrizFilial: IdentificadorMatrizFilial[] = [
    identificadorMatriz,
    identificadorFilial
];

/** Verifica se o identificador é Matriz */
export function isIdentificadorMatriz(identificador: number): boolean {
    return identificador === identificadorMatriz.id;
}

/** Verifica se o identificador é Filial */
export function isIdentificadorFilial(identificador: number): boolean {
    return identificador === identificadorFilial.id;
}
